import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { verifyMember } from '../services/api';

function VerifyMemberPage() {
  const [civilId, setCivilId] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) navigate('/verifier-login');
  }, [navigate]);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!civilId.trim()) return;
    setLoading(true);
    setResult(null);
    try {
      const res = await verifyMember({ civilIdNo: civilId.trim(), verifiedBy: localStorage.getItem('username') });
      setResult(res.data);
    } catch {
      setResult({ status: 'ERROR' });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/verifier-login');
  };

  const statusConfig = {
    VERIFIED: { bg: '#4caf50', icon: '✅', text: 'Verified & Active Member' },
    NOT_FOUND: { bg: '#f44336', icon: '❌', text: 'Member Not Found' },
    NOT_APPROVED: { bg: '#ff9800', icon: '⚠️', text: 'Member Not Approved' },
    EXPIRED: { bg: '#f44336', icon: '⏰', text: 'Membership Expired' },
    ERROR: { bg: '#9e9e9e', icon: '⚠️', text: 'Verification Failed' },
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1a472a 0%, #2d5f3f 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{ width: '100%', maxWidth: '500px', padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img src={process.env.PUBLIC_URL + '/misk_logo.png'} alt="MISK" style={{ height: '50px' }} />
            <span style={{ color: '#fff', fontSize: '18px', fontWeight: 'bold' }}>Member Verification</span>
          </div>
          <button onClick={handleLogout} style={{ padding: '8px 16px', background: 'rgba(255,255,255,0.2)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>
            Logout
          </button>
        </div>

        <div style={{ background: '#fff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' }}>
          <form onSubmit={handleVerify}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>Enter Civil ID Number</label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input type="text" value={civilId} onChange={e => setCivilId(e.target.value)} placeholder="Civil ID"
                style={{ flex: 1, padding: '12px', border: '2px solid #ddd', borderRadius: '6px', fontSize: '16px' }} />
              <button type="submit" disabled={loading}
                style={{ padding: '12px 24px', background: '#2d5f3f', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '16px', cursor: loading ? 'wait' : 'pointer', opacity: loading ? 0.7 : 1, whiteSpace: 'nowrap' }}>
                {loading ? '...' : 'Verify'}
              </button>
            </div>
          </form>

          {result && (
            <div style={{ marginTop: '24px', padding: '24px', borderRadius: '8px', background: statusConfig[result.status]?.bg || '#9e9e9e', color: '#fff', textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>{statusConfig[result.status]?.icon}</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '8px' }}>{statusConfig[result.status]?.text}</div>
              {result.name && result.status === 'VERIFIED' && (
                <div style={{ fontSize: '24px', marginTop: '12px', padding: '12px', background: 'rgba(255,255,255,0.2)', borderRadius: '6px' }}>
                  {result.name}
                </div>
              )}
            </div>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: '20px', color: 'rgba(255,255,255,0.5)', fontSize: '12px' }}>
          Logged in as: {localStorage.getItem('name') || localStorage.getItem('username')}
        </div>
      </div>
    </div>
  );
}

export default VerifyMemberPage;
